module.exports = __webpack_public_path__ + "images/emoji/mahjong.68fb739eb2eb5d2b4adf.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/mahjong.png
// module id = hYdy
// module chunks = 14